import { generatePath } from 'react-router'

import { useAddressStore } from '@features/shipping-methods'

import { ProductCarousel } from '@widgets/product-carousel'


import { IMAGE_SIZES, URL_PAGE_PRODUCT_GROUP } from '@shared/contants'
import { Product, useProductsPreviewCardQuery, useSingleProductGroupQuery } from '@shared/generated'

type ProductsGroupCarouselProps = {
  id: string
}

export default function ProductsGroupCarousel ({
  id
}: ProductsGroupCarouselProps) {
  const { shopId } = useAddressStore()
  
  const { data: productGroupData, loading: productGroupLoading } = useSingleProductGroupQuery({
    variables: {
      id,
      shop_id: shopId,
      style: IMAGE_SIZES.LARGE,
    }
  })
  const { data, loading } = useProductsPreviewCardQuery({
    variables: {
      shopId: shopId,
      filter: {
        fields: [ 'productGroupIds' ],
        op: 'contains',
        value: [ id ]
      },
    }
  })

  return (
    <>
      {data && data.products?.edges && data.products?.edges?.length > 0 && (
        <ProductCarousel
          link={generatePath(URL_PAGE_PRODUCT_GROUP, { productGroupId: id })}
          title={productGroupData?.singleProductGroup?.label ?? ''}
          products={data.products?.edges as Product[]}
          loading={loading || productGroupLoading}
        />
      )}
    </>
  )
};